import * as React from "react";
import {
  StyleSheet,
  Text,
  View,
} from "react-native";

export default class Tag extends React.PureComponent {
    constructor(props) {
      super(props);
      this.state = {};
    }

    render() {
      return (
        <View style={styles.item}>
            <Text style={styles.title}>{this.props.title}</Text>
        </View>
    );
  };
}

const styles = StyleSheet.create({
    container: {
      flex: 1,
    },
    item: {
      height:"100%",
      backgroundColor: 'black',
      borderRadius: 40,
      alignItems: "center",
      justifyContent: "center",
      marginRight: 5,
      paddingLeft: 8,
      paddingRight: 8,
      paddingTop: 3,
      paddingBottom: 3,
    },
    title: {
      fontSize: 12,
      color: 'white'
    },
  });